const headingRegex = /^(##) (.*)(\n)/gm;
const headingWithUnderscoresRegex = /^(.*)(\n)(.-)(.*)/gm;

const lowerCaseList = ['of', 'and', 'the', 'to'];

function toTitleCase(str: string) {
  return str.replace(/\p{L}+/gu, function (txt) {
    if (str.indexOf(txt) !== 0 && lowerCaseList.includes(txt.toLowerCase())) {
      return txt.toLowerCase();
    }
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function getTableOfContentsItems(markdownText: string) {
  const allMatchedHeadingBlocks = [...markdownText.matchAll(headingRegex)] ?? [];
  const allMatchedHeadingWithUnderscoreBlocks = [...markdownText.matchAll(headingWithUnderscoresRegex)] ?? [];

  return [
    ...allMatchedHeadingBlocks.map((matchedBlock) => toTitleCase(matchedBlock[2])),
    ...allMatchedHeadingWithUnderscoreBlocks.map((matchedBlock) => toTitleCase(matchedBlock[1])),
  ];
}
